"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuerySortTypeEnum = void 0;
class QuerySortTypeEnum {
    constructor() { }
}
exports.QuerySortTypeEnum = QuerySortTypeEnum;
QuerySortTypeEnum.None = 0;
QuerySortTypeEnum.UpPrice = 1;
QuerySortTypeEnum.DownPrice = 2;
QuerySortTypeEnum.DownRate = 4;
//# sourceMappingURL=QuerySortTypeEnum.js.map